<template>
    <div
        v-if="checkShowStatus"
        class="font-bold">
        <span v-if="CLable">
            {{ CLable }}:
        </span>

        <span
            v-if="getObjectStatus.label"
            :class="getObjectStatus.class"
            class="font-medium mr-2 dark:bg-blue-900 dark:text-blue-300 shadow-lg select-none">
            {{ getObjectStatus.label || '' }}
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object,
  module: {
    type: String
  },
  status: {
    type: [String, Number]
  },
  size: {
    type: String,
    default: 'default'
  },
  label: {
    type: String,
    default: 'Trạng thái'
  },
  keyStatus: {
    type: String
  }
})

const { params, module, status, size, label, keyStatus } = toRefs(props)

const checkShowStatus = computed(() => {
  if (!params?.value?.check) {
    return true
  }
  return params?.value.check(params?.value?.data)
})

const CModule = computed(() => {
  return params?.value?.module || module?.value
})

const CKeyStatus = computed(() => {
  return params?.value?.keyStatus || keyStatus?.value
})

const CStatus = computed(() => {
  if (params?.value && CKeyStatus.value) {
    return params?.value?.data?.[CKeyStatus.value]
  }

  if (typeof params?.value?.data?.status === 'number') {
    return params.value.data.status
  }

  if (typeof status?.value === 'number') {
    return status.value
  }
  return null
})

const CSize = computed(() => {
  return params?.value?.size || size?.value
})

const CLable = computed(() => {
  if (typeof params?.value?.label === 'string') {
    return params?.value?.label
  }
  return label.value
})

const getStatusModule: { [key: string]: any } = {
  vehicles: {
    1: { label: $t('labels.readyShip'), class: 'bg-success-100 text-success-800' },
    '-1': { label: $t('labels.vehicleModule.notReady'), class: 'bg-error-100 text-error-800' }
  },
  driver: {
    0: { label: $t('labels.notReadyYet'), class: 'bg-error-100 text-error-800' },
    1: { label: $t('labels.conditionallyReady'), class: 'bg-success-100 text-success-800' },
    2: { label: $t('labels.ready'), class: 'bg-success-100 text-success-800' }
  },
  order: {
    0: { label: 'pending', class: 'bg-yellow-100 text-yelow-800' },
    1: { label: 'active', class: 'bg-blue-100 text-blue-800' },
    2: { label: 'complete', class: 'bg-success-100 text-success-800' }
  },
  quote: {
    0: { label: $t('labels.init'), class: 'bg-yellow-100 text-yelow-800' },
    1: { label: $t('labels.send'), class: 'bg-blue-100 text-blue-800' },
    2: { label: $t('labels.orderCreated'), class: 'bg-success-100 text-success-800' },
    3: { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' }
  },
  quoteRequest: {
    0: { label: $t('labels.init'), class: 'bg-yellow-100 text-yelow-800' },
    1: { label: $t('labels.quoteCreated'), class: 'bg-success-100 text-success-800' },
    3: { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' }
  },
  orderStatus: {
    1: { label: 'Chưa thực hiện', class: 'bg-gray-100 text-gray-800' },
    2: { label: 'Đang thực hiện', class: 'bg-info-100 text-info-800' },
    3: { label: 'Hoàn thành', class: 'bg-success-100 text-success-800' },
    '-1': { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' }
  },
  orderAllocationStatus: {
    '-1': { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' },
    1: { label: 'Thiếu báo giá', class: 'bg-violet-100 text-violet-800' },
    2: { label: 'Thiếu thời gian tối ưu', class: 'bg-amber-100 text-amber-800' },
    3: { label: 'Thiếu báo giá & thời gian tối ưu', class: 'bg-orange-100 text-orange-800' },
    4: { label: 'Chờ phân bổ', class: 'bg-gray-100 text-gray-800' },
    5: { label: 'Phân bổ dở dang', class: 'bg-info-100 text-info-800' },
    6: { label: 'Hoàn tất phân bổ', class: 'bg-success-100 text-success-800' }
  },
  journeyStatus: {
    '-1': { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' }, // Hủy
    1: { label: 'Chờ xác nhận', class: 'bg-yellow-100 text-yellow-800' }, // Vàng
    2: { label: 'Chờ điều xe', class: 'bg-blue-100 text-blue-800' }, // Xanh dương
    3: { label: 'Có xe dự kiến', class: 'bg-orange-100 text-orange-800' }, // Cam
    4: { label: 'Có xe chính thức', class: 'bg-green-100 text-green-800' }, // Xanh lá cây
    5: { label: 'Đang vận chuyển', class: 'bg-green-200 text-green-800' }, // Xanh lá cây đậm
    6: { label: 'Kết thúc chặng', class: 'bg-gray-100 text-gray-800' }, // Xám
    7: { label: 'Chờ điều đội xe', class: 'bg-sky-100 text-sky-800' } // Xanh nhạt
  },
  tripStatus: {
    '-1': { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' }, // Hủy: Màu đỏ
    1: { label: 'Chưa thực hiện', class: 'bg-gray-100 text-gray-800' }, // Chưa thực hiện: Màu xám
    2: { label: 'Đang thực hiện', class: 'bg-blue-100 text-blue-800' }, // Đang thực hiện: Màu xanh dương nhạt
    3: { label: 'Hoàn thành', class: 'bg-green-100 text-green-800' } // Hoàn thành: Màu xanh lá cây
  },
  tripModerationStatus: {
    '-1': { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' }, // Hủy (Đỏ)
    1: { label: 'Chờ xác nhận', class: 'bg-yellow-100 text-yellow-800' }, // Vàng
    2: { label: 'Chờ điều xe', class: 'bg-blue-100 text-blue-800' }, // Xanh dương
    3: { label: 'Có xe dự kiến', class: 'bg-orange-100 text-orange-800' }, // Cam
    4: { label: 'Có xe chính thức', class: 'bg-green-100 text-green-800' }, // Xanh lá cây
    5: { label: 'Chờ điều đội xe', class: 'bg-sky-100 text-sky-800' } // Xanh nhạt
  },
  customerStatus: {
    1: { label: 'Lead', class: 'bg-info-100 text-info-800' },
    2: { label: 'Prospect', class: 'bg-info-100 text-info-800' },
    3: { label: 'Opportunity', class: 'bg-info-100 text-info-800' },
    4: { label: 'Customer', class: 'bg-pink-100 text-pink-800' }
  },
  vehicleExploit: {
    true: { label: $t('labels.exploiting'), class: 'bg-success-100 text-success-800' },
    false: { label: $t('labels.stopExploit'), class: 'bg-error-100 text-error-800' }
  },
  vehicleManagementApprove: {
    true: { label: $t('labels.approved'), class: 'bg-success-100 text-success-800' },
    false: { label: $t('labels.waittingApprove'), class: 'bg-warning-100 text-warning-800' }
  },
  remoocAssignStatus: {
    1: { label: $t('labels.remoocModule.active'), class: 'bg-success-100 text-success-800' },
    '-1': { label: $t('labels.remoocModule.inactive'), class: 'bg-error-100 text-error-800' }
  },
  partnerStatusConfirmMarkup: {
    0: { label: $t('labels.pendingApproval'), class: 'bg-yellow-100 text-yelow-800' },
    1: { label: $t('labels.approved'), class: 'bg-blue-100 text-success-800' },
    2: { label: $t('labels.reject'), class: 'bg-success-100 text-error-800' }
  },
  integrationInternalStatus: {
    pending: {
      label: $t('labels.pendingApproval'),
      class: 'bg-yellow-100 text-yellow-800'
    },
    accepted: {
      label: $t('labels.approved'),
      class: 'bg-green-100 text-green-800'
    },
    rejected: {
      label: $t('labels.reject'),
      class: 'bg-red-100 text-red-800'
    }
  },
  debitStatus: {
    pending: {
      label: 'Chờ xác nhận',
      class: 'bg-yellow-100 text-yellow-800'
    },
    active: {
      label: 'Xác nhận',
      class: 'bg-green-100 text-green-800'
    }
  },
  invoiceStatus: {
    pending: {
      label: 'Chờ xác nhận',
      class: 'bg-yellow-100 text-yellow-800'
    },
    active: {
      label: 'Xác nhận',
      class: 'bg-green-100 text-green-800'
    },
    sent: {
      label: 'Đã gửi',
      class: 'bg-blue-100 text-blue-800'
    },
    partial: {
      label: 'Thanh toán một phần',
      class: 'bg-purple-100 text-purple-800'
    },
    paid: {
      label: 'Đã thanh toán',
      class: 'bg-green-100 text-green-800'
    },
    overdue: {
      label: 'Quá hạn',
      class: 'bg-red-100 text-red-800'
    },
    partialOverdue: {
      label: 'Quá hạn một phần',
      class: 'bg-orange-100 text-orange-800'
    }
  },
  bookingStatus: {
    '-1': { label: $t('labels.cancel'), class: 'bg-error-100 text-error-800' },
    0: { label: $t('labels.reject'), class: 'bg-error-100 text-error-800' },
    1: { label: 'Chờ xác nhận', class: 'bg-gray-100 text-gray-800' },
    2: { label: 'Đã xác nhận', class: 'bg-info-100 text-info-800' },
    3: { label: 'Đang vận chuyển', class: 'bg-warning-100 text-warning-800' },
    4: { label: 'Hoàn thành', class: 'bg-success-100 text-success-800' }
  }
}

const getObjectStatus = computed(() => {
  let status = CStatus.value

  let classT = getStatusModule[CModule.value][String(status)] || {}
  if (CSize.value === 'default') {
    classT.class += ' text-sm px-2.5 py-0.5 rounded'
  }
  if (CSize.value === 'medium') {
    classT.class += ' text-[14px] font-medium p-[6px] py-0.5 rounded'
  }
  if (CSize.value === 'large') {
    classT.class += ' text-[18px] font-medium mr-2 p-[8px] rounded-xl'
  }

  if (CModule.value === 'orderAllocationStatus') {
    const { allotted, productivityOrder } = params?.value?.data || {}

    if (allotted) {
      status = 5
    }

    if (allotted === productivityOrder) {
      status = 6
    }

    classT = getStatusModule[CModule.value][String(status)] || {}
    if (CSize.value === 'default') {
      classT.class += ' text-sm px-2.5 py-0.5 rounded'
    }
    if (CSize.value === 'medium') {
      classT.class += ' text-[14px] font-medium p-[6px] py-0.5 rounded'
    }
    if (CSize.value === 'large') {
      classT.class += ' text-[18px] font-medium mr-2 p-[8px] rounded-xl'
    }

    if ([4, 5, 6].includes(CStatus.value)) {
      if (typeof allotted === 'number' && typeof productivityOrder === 'number') {
        return {
          label: classT.label + ` ${allotted}/${productivityOrder}`,
          class: classT.class
        }
      }
    }
  }

  return classT
})
</script>

<style scoped></style>
